module.exports = __webpack_public_path__ + "img/icon_book.f0ced626.svg";